import { AppUiVariant } from '../../../core/src/shared/enums';
import { APP_UI_VARIANT } from '../config';

export const brightOrange = '#FF9B3D';

const defaultVariantColors = {
  brightOrange,
};

const ryseVariantColors = {
  blumine: '#1D5D74',
};

const solidsunVariantColors = {
  guardsmanRed: '#d40000',
};

const currentVariantColors: Record<
  AppUiVariant,
  { primary: string; richBlack?: string }
> = {
  [AppUiVariant.Default]: {
    primary: defaultVariantColors.brightOrange,
  },
  [AppUiVariant.Ryse]: {
    primary: ryseVariantColors.blumine,
  },
  [AppUiVariant.Innogy]: {
    primary: defaultVariantColors.brightOrange,
  },
  [AppUiVariant.Solidsun]: {
    primary: solidsunVariantColors.guardsmanRed,
    richBlack: '#000d20',
  },
};

export const colors = {
  lightBlue: '#F4F8FC',
  richBlack: '#071326',
  darkBlue: '#3E6879',
  dodgerBlue: '#3DA7FF',
  white: '#fff',
  brightOrange,
  ...currentVariantColors[APP_UI_VARIANT],
};

export const darkColors = {
  background: '#121212',
  paper: '#2c2c2c',
  richBlack: '#e4e4e4',
  darkBlue: '#a8c5d1',
  lightBlue: '#2a2a2a',
};
